export const SHOW_JOIN_COMMUNITY_POINTS_THRESHOLD = 1500;
export const SHOW_CONTRIBUTE_TO_COMMUNITY_POINTS_THRESHOLD = 25_000;
export const IS_JOIN_COMMUNITY_DISMISSED_KEY = 'isJoinCommunityDismissed';
export const IS_CONTRIBUTE_TO_COMMUNITY_DISMISSED_KEY = 'isContributeToCommunityDismissed';
export const IS_SHOW_CHALLENGES_BANNER_DISMISSED_KEY = 'isChallengesBannerDismissed';
export const CHALLENGES_BANNER_FIRST_VISIBLE_DATE = 'challengesBannerFirstVisibleDate';
export const SHOW_ACCESS_NETWORKS_STREAK_THRESHOLD = 7;
export const IS_ACCESS_NETWORKS_DISMISSED_KEY = 'isAccessNetworksDismissed';
export const IS_RECAPME_AD_SHOWING_KEY = 'THM_ShowReCapMeAd';
export const IS_CERTIFICATION_RELEASE_DISMISSED = 'isCertificationReleaseDismissed';
export const IS_PT1_CERTIFICATION_RELEASE_DISMISSED = 'isPT1CertificationReleaseDismissed';
export const IS_TTX_ADVERTISEMENT_B2B_DISMISSED_KEY = 'isTtxAdvertisementB2bDismissed';
export const IS_TTX_ADVERTISEMENT_NON_B2B_DISMISSED_KEY = 'isTtxAdvertisementNonB2bDismissed';
export const IS_INFLUENCER_CAMPAIGN_BAR_DISMISSED_KEY = 'isInfluencerCampaignBarDismissed';
export const IS_TH_CERTIFICATION_RELEASE_DISMISSED = 'isTHCertificationReleaseDismissed';
